var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-upload-info-container" },
    [
      _c(
        "el-upload",
        {
          attrs: {
            action: _vm.env.VUE_APP_fileserver + "persistentUpload",
            "show-file-list": false,
            "before-upload": _vm.beforeUploadCheck,
            "on-progress": _vm.uploadProgress,
            "on-success": _vm.uploadSuccess
          }
        },
        [
          _vm.videoUrl
            ? _c("div", { staticClass: "video-box" }, [
                _c(
                  "video",
                  {
                    staticClass: "video-player",
                    attrs: { src: _vm.videoUrl, controls: "" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  },
                  [_vm._v("您的浏览器不支持视频播放")]
                ),
                _c("i", {
                  staticClass: "el-icon-circle-close delete-video-icon",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.deleteVideoClick($event)
                    }
                  }
                })
              ])
            : [
                !_vm.isShowProgress
                  ? _c("div", { staticClass: "plus-box" }, [
                      _c("i", { staticClass: "el-icon-plus plus-icon" })
                    ])
                  : _c("el-progress", {
                      attrs: { type: "circle", percentage: _vm.percent }
                    })
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }